import type { SVGProps } from 'react';

const SvgCoinLinear = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="vuesax/linear/coin">
      <path
        id="Vector"
        d="M12.3334 8.93359V11.4003C12.3334 13.4803 10.3934 15.1669 8.00002 15.1669C5.60669 15.1669 3.66669 13.4803 3.66669 11.4003V8.93359C3.66669 11.0136 5.60669 12.5003 8.00002 12.5003C10.3934 12.5003 12.3334 11.0136 12.3334 8.93359Z"
        stroke="#85888E"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M12.3334 5.60004C12.3334 6.20671 12.1667 6.76671 11.8734 7.24671C11.16 8.42004 9.69335 9.16671 8.00002 9.16671C6.30669 9.16671 4.84002 8.42004 4.12669 7.24671C3.83336 6.76671 3.66669 6.20671 3.66669 5.60004C3.66669 4.56004 4.15335 3.62004 4.93335 2.94004C5.72002 2.25337 6.80002 1.83337 8.00002 1.83337C9.20002 1.83337 10.28 2.25338 11.0667 2.93338C11.8467 3.62004 12.3334 4.56004 12.3334 5.60004Z"
        stroke="#85888E"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M12.3334 5.60004V8.93338C12.3334 11.0134 10.3934 12.5 8.00002 12.5C5.60669 12.5 3.66669 11.0134 3.66669 8.93338V5.60004C3.66669 3.52004 5.60669 1.83337 8.00002 1.83337C9.20002 1.83337 10.28 2.25338 11.0667 2.93338C11.8467 3.62004 12.3334 4.56004 12.3334 5.60004Z"
        stroke="#85888E"
        strokeWidth={0.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default SvgCoinLinear;
